var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 0C5.5971 0 0 5.5971 0 12.5C0 19.4029 5.5971 25 12.5 25C19.4029 25 25 19.4029 25 12.5C25 5.5971 19.4029 0 12.5 0ZM16.5206 12.6925L10.4269 17.1261C10.3935 17.1501 10.3541 17.1645 10.3131 17.1675C10.2721 17.1706 10.231 17.1623 10.1944 17.1436C10.1577 17.1248 10.127 17.0964 10.1055 17.0613C10.084 17.0262 10.0726 16.9859 10.0725 16.9448V8.08315C10.0724 8.04193 10.0837 8.00147 10.1051 7.96627C10.1266 7.93107 10.1574 7.90249 10.1941 7.88371C10.2308 7.86493 10.2719 7.85668 10.313 7.85987C10.3541 7.86306 10.3935 7.87757 10.4269 7.90179L16.5206 12.3326C16.5494 12.3529 16.5729 12.3799 16.5891 12.4112C16.6053 12.4425 16.6138 12.4773 16.6138 12.5126C16.6138 12.5478 16.6053 12.5826 16.5891 12.6139C16.5729 12.6452 16.5494 12.6722 16.5206 12.6925Z",
    fill: "#794BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).0060b61052596b8d359d195954b1fe3d.svg";
export { ForwardRef as ReactComponent };